import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Department: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Department',
  minWidth: 100,
  maxWidth: 136,
  accessorFn: (product) => product.department,
});
